<template>
	<div class="filter-menu">
		<Button
			icon="fal fa-filter"
			outlined
			@click="toggleMenu" />
		<Menu
			ref="menu"
			popup
			:model="menuModel" />
	</div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import Button from 'primevue/button'
import Menu from 'primevue/menu'
import type { FilterControls } from '@/helpers/filters/FilterControls'
import type { Filters } from '@/helpers/filters/Filters'

const emit = defineEmits<{
	(e: 'updated'): void
}>()

const props = defineProps<{ controls: FilterControls<any>; filters: Filters<any> }>()

const menu = ref<InstanceType<typeof Menu>>()

const menuModel = computed(() =>
	props.controls.items.map((i) => ({
		label: i.name,
		icon: i.icon,
		command: () => {
			const f = props.controls.defaultFilterFor(i.key)
			if (f) {
				props.filters.list.add(f)
			}
			emit('updated')
		},
	})),
)

function toggleMenu(event: MouseEvent) {
	menu.value?.toggle(event)
}
</script>

<style scoped lang="scss"></style>
